/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  CreateTransferLineItemValidationError,
  CreateTransferLineItemValidationError$inboundSchema,
  CreateTransferLineItemValidationError$Outbound,
  CreateTransferLineItemValidationError$outboundSchema,
} from "./createtransferlineitemvalidationerror.js";

export type CreateTransferLineItemsValidationError = {
  items?: { [k: string]: CreateTransferLineItemValidationError } | undefined;
};

/** @internal */
export const CreateTransferLineItemsValidationError$inboundSchema: z.ZodType<
  CreateTransferLineItemsValidationError,
  z.ZodTypeDef,
  unknown
> = z.object({
  items: z.record(CreateTransferLineItemValidationError$inboundSchema)
    .optional(),
});
/** @internal */
export type CreateTransferLineItemsValidationError$Outbound = {
  items?:
    | { [k: string]: CreateTransferLineItemValidationError$Outbound }
    | undefined;
};

/** @internal */
export const CreateTransferLineItemsValidationError$outboundSchema: z.ZodType<
  CreateTransferLineItemsValidationError$Outbound,
  z.ZodTypeDef,
  CreateTransferLineItemsValidationError
> = z.object({
  items: z.record(CreateTransferLineItemValidationError$outboundSchema)
    .optional(),
});

export function createTransferLineItemsValidationErrorToJSON(
  createTransferLineItemsValidationError:
    CreateTransferLineItemsValidationError,
): string {
  return JSON.stringify(
    CreateTransferLineItemsValidationError$outboundSchema.parse(
      createTransferLineItemsValidationError,
    ),
  );
}
export function createTransferLineItemsValidationErrorFromJSON(
  jsonString: string,
): SafeParseResult<CreateTransferLineItemsValidationError, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      CreateTransferLineItemsValidationError$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CreateTransferLineItemsValidationError' from JSON`,
  );
}
